import { axiosInstance } from '../api';

export default function(userId, token, newPassword) {
    return axiosInstance.post('/api/reset/changePassword', {
        "userId": userId,
        "token": token,
        "newPassword": newPassword
    });
}